import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {

  constructor() { }

  public initAmplitude(userEmail: string) {
    const sessionReplayTracking = sessionReplayPlugin();
    amplitude.add(sessionReplayTracking);

    amplitude.init('d9975e56e53d0bd91d490b2f8cae1bec', userEmail, {
      defaultTracking: true,
      autocapture: true,
      fetchRemoteConfig: true,
      deviceId: amplitude.getDeviceId(),
    });
  }

  public trackEvent(eventName: string, eventData?: any) {
    amplitude.track(eventName, eventData);
  }
}
